import React from "react";
import { NavLink } from "react-router-dom";
import "./NavButtons.css";

function NavButtons() {
  return (
    <div className="nav-buttons">
      <NavLink className="nav-button clickable" to="/GitVersioniser/features">
        Features
      </NavLink>
      <NavLink
        className="nav-button clickable"
        to="/GitVersioniser/start"
      >
        Quick Start
      </NavLink>
    </div>
  );
}

export default NavButtons;
